import de from 'date-fns/locale/de';
import enCA from 'date-fns/locale/en-CA';
import enGB from 'date-fns/locale/en-GB';
import enNZ from 'date-fns/locale/en-NZ';
import enUS from 'date-fns/locale/en-US';
import frCA from 'date-fns/locale/fr-CA';
import frCH from 'date-fns/locale/fr-CH';

import { CURRENCY_CODE_FORMAT, LANGUAGES, LOCALES, MONEY_FORMAT, REGIONS } from 'state/intl/types';

export const LOCALE_DATA = {
  [LOCALES.en_us]: {
    code: LOCALES.en_us,
    region: REGIONS.US,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_us,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_us,
    dateFormat: enUS,
  },
  [LOCALES.en_gb]: {
    code: LOCALES.en_gb,
    region: REGIONS.GB,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_gb,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_gb,
    dateFormat: enGB,
  },
  [LOCALES.en_ca]: {
    code: LOCALES.en_ca,
    region: REGIONS.CA,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_ca,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_ca,
    dateFormat: enCA,
  },
  [LOCALES.en_za]: {
    code: LOCALES.en_za,
    region: REGIONS.ZA,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_za,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_za,
    dateFormat: enGB, // using EU format for now (date-fns needs to support enZA)
  },
  [LOCALES.fr_ca]: {
    code: LOCALES.fr_ca,
    region: REGIONS.CA,
    language: LANGUAGES.fr,
    moneyFormat: MONEY_FORMAT.fr_ca,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.fr_ca,
    dateFormat: frCA,
  },
  [LOCALES.en_ch]: {
    code: LOCALES.en_ch,
    region: REGIONS.CH,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_ch,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_ch,
    dateFormat: frCH,
  },
  [LOCALES.de_ch]: {
    code: LOCALES.de_ch,
    region: REGIONS.CH,
    language: LANGUAGES.de,
    moneyFormat: MONEY_FORMAT.de_ch,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.de_ch,
    dateFormat: frCH,
  },
  [LOCALES.fr_ch]: {
    code: LOCALES.fr_ch,
    region: REGIONS.CH,
    language: LANGUAGES.fr,
    moneyFormat: MONEY_FORMAT.fr_ch,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.fr_ch,
    dateFormat: frCH,
  },
  [LOCALES.it_ch]: {
    code: LOCALES.it_ch,
    region: REGIONS.CH,
    language: LANGUAGES.it,
    moneyFormat: MONEY_FORMAT.it_ch,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.it_ch,
    dateFormat: frCH,
  },
  [LOCALES.en_de]: {
    code: LOCALES.en_de,
    region: REGIONS.DE,
    language: LANGUAGES.de,
    moneyFormat: MONEY_FORMAT.en_de,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_de,
    dateFormat: de,
  },
  [LOCALES.de_de]: {
    code: LOCALES.de_de,
    region: REGIONS.DE,
    language: LANGUAGES.de,
    moneyFormat: MONEY_FORMAT.de_de,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.de_de,
    dateFormat: de,
  },
  [LOCALES.en_nz]: {
    code: LOCALES.en_nz,
    region: REGIONS.NZ,
    language: LANGUAGES.en,
    moneyFormat: MONEY_FORMAT.en_nz,
    currencyCodeFormat: CURRENCY_CODE_FORMAT.en_nz,
    dateFormat: enNZ,
  },
};
